var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}]}),_c('body',[_c('router-view')],1),_c('div',{staticClass:"spacer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }